import { centsToFixed2 } from '../utils';

export const gtagEventPurchase = (bookingId: string, actionPayload: any, currency: string, send_to?: string) => {
  const data = {
    transaction_id: bookingId,
    value: +centsToFixed2(actionPayload?.cart?.discountedPriceWithoutDeposit.net), // Total transaction value (incl. tax and shipping)
    tax: +centsToFixed2(actionPayload?.cart?.discountedPriceWithoutDeposit.vat),
    currency: currency,
    items: actionPayload?.cart?.items?.map((item, index) => ({
      item_id: item.itemId,
      item_name: item.name,
      index: index,
      price: +centsToFixed2(item.discountedPrice?.net),
      quantity: item.qty,
    })),
  };

  if (send_to) {
    const dataWithSendTo = {
      ...data,
      send_to: send_to,
    };

    gtag('event', 'conversion', dataWithSendTo);
    return;
  }

  gtag('event', 'purchase', data);
};

export const gtagEventAddToCart = (params: any, currency: string) => {
  gtag('event', 'add_to_cart', {
    currency: currency,
    value: params.price?.net ? +centsToFixed2(params.price.net) : undefined,
    items: [
      {
        item_id: params.itemId,
        item_name: params.name,
        index: 0,
      },
    ],
  });
};

export const gtagEventInitiateCheckout = (state: any) => {
  gtag('event', 'begin_checkout', {
    currency: state.currency,
    value: +centsToFixed2(state.amountToPay.total),
  });
};

export const gtagEventAddShippingInfo = (state: any) => {
  gtag('event', 'add_shipping_info', {
    currency: state.currency,
    value: +centsToFixed2(state.amountToPay.total),
  });
};

export const gtagEventAddCustomer = (actionPayload: any) => {
  const normalizedPhoneNumber = normalizePhoneNumber(actionPayload.phoneNumber);

  const address = {
    ...((actionPayload['shipping.firstName'] || actionPayload.firstName) && { first_name: actionPayload['shipping.firstName'] || actionPayload.firstName }),
    ...((actionPayload['shipping.lastName'] || actionPayload.lastName) && { last_name: actionPayload['shipping.lastName'] || actionPayload.lastName }),
    ...((actionPayload['shipping.city'] || actionPayload.city) && { city: actionPayload['shipping.city'] || actionPayload.city }),
    ...((actionPayload['shipping.zipCode'] || actionPayload.zipCode) && { postal_code: actionPayload['shipping.zipCode'] || actionPayload.zipCode }),
    ...((actionPayload['shipping.country'] || actionPayload.country) && { country: actionPayload['shipping.country'] || actionPayload.country }),
  };
  const body = {
    email: actionPayload.email,
    ...(normalizedPhoneNumber && { phone_number: normalizePhoneNumber(normalizedPhoneNumber) }),
    ...(address && { address: address }),
  };

  gtag('set', 'user_data', body);

  function normalizePhoneNumber(phoneNumber: string) {
    // Must be in E.164 format, which means it must be 11 to 15 digits including a plus sign (+) prefix and country code with no dashes, parentheses, or spaces.
    // Example: ‘+11231234567’
    phoneNumber = phoneNumber.replace(/\s/g, '');
    if (phoneNumber.length < 11 || phoneNumber.length > 15 || !phoneNumber.startsWith('+') || !/^\+?[1-9]\d{1,14}$/.test(phoneNumber)) {
      return null;
    }

    return phoneNumber;
  }
};
